import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import {
  Modal,
  Button,
  ToastContainer,
  Toast
} from '@salesforce/design-system-react';

import './CreateDataExtensionModal.scss';

export class CreateDataExtensionModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showError: false,
      showSuccess: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.dataExtension !== prevProps.dataExtension) {
      if (
        this.props.dataExtension.saveSuccess &&
        !this.props.dataExtension.error
      ) {
        this.setState({ showSuccess: true });
      }
      if (this.props.dataExtension.error) {
        if (
          !this.props.dataExtension.saveSuccess &&
          this.props.dataExtension.saveSuccess !== null &&
          !this.props.dataExtension.error.response.ok
        ) {
          this.setState({ showError: true });
        }
      }
    }
  }

  handleClose() {
    this.props.actions.closeModal('createDataExtension');
  }

  handleCreateDataExtension() {
    this.props.actions.submitCreateDataExtension(
      {},
      this.props.dataExtension.dataFilter
    );
    this.props.actions.closeModal('createDataExtension');
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen = this.props.modals.createDataExtension
      ? this.props.modals.createDataExtension.isOpen
      : false;
    const showRange =
      this.props.dataExtension.dataFilter.rangeStart ||
      this.props.dataExtension.dataFilter.rangeEnd;
    return (
      <div>
        <ToastContainer>
          {this.state.showSuccess ? (
            <Toast
              labels={{
                heading: formatMessage({
                  id: 'CreateDataExtensionModal.toasts.success.heading'
                }),
                details: formatMessage({
                  id: 'CreateDataExtensionModal.toasts.success.details'
                })
              }}
              onRequestClose={() => {
                this.setState({ showSuccess: false });
              }}
              variant="success"
              duration={8000}
            />
          ) : null}
          {this.state.showError ? (
            <Toast
              labels={{
                heading: formatMessage({
                  id: 'CreateDataExtensionModal.toasts.error.heading'
                })
              }}
              onRequestClose={() => {
                this.setState({ showError: false });
              }}
              variant="error"
            />
          ) : null}
        </ToastContainer>
        <Modal
          containerClassName="create-data-extension-modal"
          isOpen={isOpen}
          onRequestClose={() => this.handleClose()}
          title={formatMessage({
            id: 'CreateDataExtensionModal.title'
          })}
          footer={[
            <Button
              label={formatMessage({
                id: 'CreateDataExtensionModal.footer.cancel'
              })}
              onClick={() => this.handleClose()}
              key="createDataExtensionCancelBtn"
            />,
            <Button
              label={formatMessage({
                id: 'CreateDataExtensionModal.footer.create'
              })}
              variant="brand"
              onClick={() => this.handleCreateDataExtension()}
              key="createDataExtensionCreateBtn"
            />
          ]}
        >
          <div className="slds-grid slds-gutters create-data-extension-modal-body">
            <div className="slds-grid slds-col slds-size_3-of-5 create-de-modal-description">
              <div className="slds-col">
                <p>
                  <FormattedMessage id="CreateDataExtensionModal.body.description" />
                </p>
                <ol className="slds-list_ordered">
                  <li>
                    <p>
                      <FormattedMessage
                        id="CreateDataExtensionModal.body.ol.1.p1"
                        values={{
                          subscriberType: (
                            <strong>
                              {formatMessage({
                                id:
                                  'CreateDataExtensionModal.body.ol.1.subscriberType'
                              })}
                            </strong>
                          )
                        }}
                      />
                    </p>
                    <p>
                      <FormattedMessage id="CreateDataExtensionModal.body.ol.1.p2" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <FormattedMessage
                        id="CreateDataExtensionModal.body.ol.2.p1"
                        values={{
                          subscriberType: (
                            <strong>
                              {formatMessage({
                                id:
                                  'CreateDataExtensionModal.body.ol.2.subscriberType'
                              })}
                            </strong>
                          )
                        }}
                      />
                    </p>
                    <p>
                      <FormattedMessage id="CreateDataExtensionModal.body.ol.2.p2" />
                    </p>
                  </li>
                </ol>
              </div>
            </div>
            <div className="slds-grid slds-col slds-size_2-of-5 create-de-modal-summary">
              <div className="slds-col">
                <h2>
                  <FormattedMessage id="CreateDataExtensionModal.body.previousDataExtension.description" />
                </h2>
                <div className="data-extension-summary">
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="CreateDataExtensionModal.body.previousDataExtension.lookback.title" />
                    </h3>
                    <h4>
                      <FormattedMessage
                        id="CreateDataExtensionModal.body.previousDataExtension.lookback.setting"
                        values={{
                          days: this.props.dataExtension.dataFilter.lookback
                        }}
                      />
                    </h4>
                  </div>
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="CreateDataExtensionModal.body.previousDataExtension.emailType.title" />
                    </h3>
                    <h4>
                      <FormattedMessage
                        id={`CreateDataExtensionModal.body.previousDataExtension.emailType.${
                          this.props.dataExtension.dataFilter.emailType
                        }`}
                      />
                    </h4>
                  </div>
                  {showRange ? (
                    <div className="de-config">
                      <h3>
                        <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.rangeStart" />
                      </h3>
                      <h4>{this.props.dataExtension.dataFilter.rangeStart}</h4>
                    </div>
                  ) : null}
                  {showRange ? (
                    <div className="de-config">
                      <h3>
                        <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.rangeEnd" />
                      </h3>
                      <h4>{this.props.dataExtension.dataFilter.rangeEnd}</h4>
                    </div>
                  ) : null}
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="CreateDataExtensionModal.body.previousDataExtension.undersaturated" />
                    </h3>
                    <h4>
                      {this.props.dataExtension.dataFilter.undersaturated}
                    </h4>
                  </div>
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="CreateDataExtensionModal.body.previousDataExtension.oversaturated" />
                    </h3>
                    <h4>{this.props.dataExtension.dataFilter.oversaturated}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

CreateDataExtensionModal.propTypes = {
  dataExtension: PropTypes.object.isRequired,
  children: PropTypes.element,
  location: PropTypes.object,
  modals: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(CreateDataExtensionModal);
